import { createItem, updateItem } from '@/api/defaultApi'

export default function (url, id, data, params = {}) {
  if (id) {
    return updateItem(url, id, data, params)
  }
  return createItem(url, data, params)
}
